import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonComponentsModule } from '@libs/common-components';
import { CommonServicesModule } from '@libs/common-services';
import { DesignSystemModule } from '@libs/design-system';
import { MAccordionComponent } from '@design-system/components/m-accordion/m-accordion.component';
import { MAccordionPanelComponent } from '@design-system/components/m-accordion-panel/m-accordion-panel.component';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AiMappingBannerComponent } from './components/ai-mapping-banner/ai-mapping-banner.component';
import { CampaignMappingUpdatePopoverComponent } from './components/campaign-mapping-update-popover/campaign-mapping-update-popover.component';
import { CampaignViewColumnHeaderComponent } from './components/campaigns-view/campaign-view-column-header/campaign-view-column-header.component';
import { CampaignViewFilterContextComponent } from './components/campaigns-view/campaign-view-filter-context/campaign-view-filter-context.component';
import { CampaignsViewComponent } from './components/campaigns-view/campaigns-view.component';
import { HeroMetricsComponent } from './components/hero-metrics/hero-metrics.component';
import { UnpublishedCampaignsComponent } from './components/review-campaigns/unpublished-campaigns.component';
import { LastElementVisibleDirective } from './helper/last-element-visibile.directive';
import { TaxonomyContainerComponent } from './taxonomy-container/taxonomy-container.component';
import { TaxonomyReviewPublishComponent } from './taxonomy-ui/taxonomy-review-publish/taxonomy-review-publish.component';
import { TaxonomyUiComponent } from './taxonomy-ui/taxonomy-ui.component';
import { AiCampaignsViewComponent } from './components/ai-campaigns-view/ai-campaigns-view.component';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { CampaignAccordionComponent } from './components/campaign-accordion/campaign-accordion.component';
import { CampaignTableComponent } from './components/campaign-table/campaign-table.component';
import { CampaignTableService } from './services/campaign-table.service';
import { CampaignAccordionService } from './services/campaign-accordion.service';
import { AiCampaignsViewService } from './services/ai-campaigns-view.service';
import { CampaignsGlobalLoaderService } from './services/campaigns-global-loader.service';
import { CampaignsConfirmationPopupService } from './services/campaigns-confirmation-popup.service';

@NgModule({
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    TableModule,
    CommonComponentsModule,
    ButtonModule,
    InputTextModule,
    ToastModule,
    CheckboxModule,
    ReactiveFormsModule,
    TooltipModule,
    DialogModule,
    CommonServicesModule,
    MessagesModule,
    ConfirmDialogModule,
    AutoCompleteModule,
    AccordionModule,
    MAccordionComponent,
    MAccordionPanelComponent,
    BadgeModule,
    InputSwitchModule,
    ListboxModule,
    TabsModule,
    DesignSystemModule,
    DividerModule,
    DatePickerModule,
    MenuModule,
    OverlayPanelModule,
    MultiSelectModule,
    SkeletonModule,
    InputGroupModule,
    InputGroupAddonModule
  ],
  exports: [TaxonomyContainerComponent],
  declarations: [
    TaxonomyUiComponent,
    TaxonomyReviewPublishComponent,
    TaxonomyContainerComponent,
    HeroMetricsComponent,
    CampaignsViewComponent,
    CampaignViewFilterContextComponent,
    LastElementVisibleDirective,
    CampaignMappingUpdatePopoverComponent,
    UnpublishedCampaignsComponent,
    CampaignViewColumnHeaderComponent,
    AiMappingBannerComponent,
    AiCampaignsViewComponent,
    CampaignAccordionComponent,
    CampaignTableComponent
  ],
  providers: [
    CampaignTableService,
    CampaignAccordionService,
    AiCampaignsViewService,
    CampaignsGlobalLoaderService,
    CampaignsConfirmationPopupService
  ]
})
export class TaxonomyUiModule {}
